import { render, staticRenderFns } from "./MyTicketTab.vue?vue&type=template&id=22e1dae6&scoped=true&"
import script from "./MyTicketTab.vue?vue&type=script&lang=js&"
export * from "./MyTicketTab.vue?vue&type=script&lang=js&"
import style0 from "./MyTicketTab.vue?vue&type=style&index=0&id=22e1dae6&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "22e1dae6",
  null
  
)

export default component.exports